<template>
  <AModal :visible.sync="visible" @cancel="cancel" v-bind="$attrs" v-on="$listeners" :afterClose="afterClose" :maskClosable="maskClosable" >
    <slot></slot>
    <template #footer>
      <div class="flex flex-center flex-bottom">
        <slot name="footer"></slot>
        <AButton v-if="okBtn" :type="okType" size="large" :icon="okIcon" :loading="loading" @click="confirm">{{ okText }}</AButton>
        <AButton v-if="cancelBtn" type="default" size="large" icon="close" :loading="loading" @click="cancel">{{ cancelText }}</AButton>
      </div>
    </template>
  </AModal>
</template>
<script>
export default {
  inheritAttrs: false,
  props: {
    /** 点击确定执行的方法 必须为promise */
    ok: {
      type: Function,
    },
    /** 是否展示确定按钮 */
    okBtn: {
      type: Boolean,
      default: true
    },
		/** 是否展示关闭按钮 */
		cancelBtn:{
			type: Boolean,
			default: true
		},
    /** 确认按钮文字 */
    okText: {
      type: String,
      default: "确认"
    },
    /** 确认按钮颜色类型 */
    okType: {
      type: String,
      default: "primary"
    },
    /** 确认按钮图标 */
    okIcon: {
      default: 'check'
    },
    /** 取消按钮文字 */
    cancelText: {
      type: String,
      default: "关闭"
    },
    /** 点击蒙层关闭 */
    maskClosable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
    };
  },
  computed:{
  },
  mounted(){
  },
  methods:{
    open(){
      this.visible = true
			this.$emit("opened")
    },
    /** 确认 */
    async confirm(){
      if(!this.ok){
        this.$message.warning("未配置接口")
        return
      }
      this.loading = true
      try{
        if(await this.ok()){
          this.cancel()
        } else {
          this.loading = false
        }
      }catch(e){
        this.loading = false
      }
    },
    /** 关闭 */
    cancel(){
      this.visible = false
    },
    /** 完全关闭 */
    afterClose(){
      this.$emit("afterClose")
      this.loading = false
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .ant-modal{

  
  .ant-modal-title{
    font-size: 24px;
    text-align: center;
    letter-spacing: 2px;
    font-weight: 700;
    color: #515151;
   
  }
 
  .ant-modal-footer{
    button{
      margin: 0 20px;
    }
  }
  .ant-modal-body{
    padding: 17px;
  }
}
</style>
